import React from 'react';
import { AppBar, Box, Button, Container, Toolbar, Typography } from '@mui/material';
import { WifiOff } from 'react-feather';
import { useNavigate } from 'react-router-dom';

import logo from '../assets/logo.png';

function NotFound() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="sm">
      <AppBar position="absolute">
        <Toolbar>
          <img src={logo} alt="Logo" style={{ width: 100 }} />
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
        }}
      >
        <WifiOff size={150} />
        <Typography variant="h4" gutterBottom>
          Oops! Página não encontrada
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          A página que você está procurando não existe ou foi movida.
        </Typography>
        <Button variant="contained" color="primary" onClick={handleClick}>
          Voltar para a página inicial
        </Button>
      </Box>
    </Container>
  );
}

export default NotFound;
